export default function SignupScreen() {
	return <h2>Signup Screen</h2>;
}
